import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useRef, cloneElement } from 'react';
import { __DEV__ } from '../../../utils/assertion.esm.js';
import '../../../utils/ssr.esm.js';
import '../../../utils/number.esm.js';
import '../../../utils/array.esm.js';
import '../../../utils/breakpoint.esm.js';
import '../../../utils/context.esm.js';
import '../../../utils/dom.esm.js';
import '../../../utils/tabbable.esm.js';
import '../../../utils/dom-query.esm.js';
import '../../../utils/logger.esm.js';
import '../../../utils/focus.esm.js';
import '../../../utils/function.esm.js';
import '../../../utils/keydown.esm.js';
import '../../../utils/lazy.esm.js';
import '../../../utils/object.esm.js';
import { cleanChildren } from '../../../utils/react-helpers.esm.js';
import '../../../utils/style-props.esm.js';
import '../../../utils/tailwind.esm.js';
import Box from '../../Box/index.esm.js';
import { useTabContext } from '../context.esm.js';
import useTabListStyles from './styles.esm.js';

var TabList = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var children = props.children,
      onKeyDown = props.onKeyDown,
      rest = _objectWithoutPropertiesLoose(props, ["children", "onKeyDown", "onClick"]);

  var styleProps = useTabListStyles();

  var _useTabContext = useTabContext(),
      id = _useTabContext.id,
      selectedIndex = _useTabContext.index,
      manualIndex = _useTabContext.manualIndex,
      onManualTabChange = _useTabContext.onManualTabChange,
      manual = _useTabContext.manual,
      onChangeTab = _useTabContext.onChangeTab,
      onFocusPanel = _useTabContext.onFocusPanel;

  var allNodes = useRef([]);
  var validChildren = cleanChildren(children);
  var focusableIndexes = validChildren.map(function (child, index) {
    return child.props.disabled === true ? null : index;
  }).filter(function (index) {
    return index != null;
  });
  var enabledSelectedIndex = focusableIndexes.indexOf(selectedIndex);
  var count = focusableIndexes.length;

  var updateIndex = function updateIndex(index) {
    var childIndex = focusableIndexes[index];
    allNodes.current[childIndex].focus();

    if (onChangeTab) {
      onChangeTab(childIndex);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      var nextIndex = (enabledSelectedIndex + 1) % count;
      updateIndex(nextIndex);
    }

    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      event.preventDefault();

      var _nextIndex = (enabledSelectedIndex - 1 + count) % count;

      updateIndex(_nextIndex);
    }

    if (event.key === 'Home') {
      event.preventDefault();
      updateIndex(0);
    }

    if (event.key === 'End') {
      event.preventDefault();
      updateIndex(count - 1);
    }

    if (event.key === 'ArrowDown') {
      event.preventDefault();

      if (onFocusPanel) {
        onFocusPanel();
      }
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var clones = validChildren.map(function (child, index) {
    var selected = manual ? index === manualIndex : index === selectedIndex;

    var handleClick = function handleClick(event) {
      // Hack for Safari. Buttons don't receive focus on click on Safari
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
      allNodes.current[index].focus();
      onManualTabChange(index);
      onChangeTab(index);

      if (child.props.onClick) {
        child.props.onClick(event);
      }
    };

    return cloneElement(child, {
      ref: function ref(node) {
        allNodes.current[index] = node;
        return node;
      },
      selected: selected,
      onClick: handleClick,
      id: id + "-" + index
    });
  });
  return React__default.createElement(Box, _extends({
    ref: ref,
    role: "tablist",
    onKeyDown: handleKeyDown
  }, styleProps, rest), clones);
});

if (__DEV__) {
  TabList.displayName = 'TabList';
}

export default TabList;
//# sourceMappingURL=index.esm.js.map
